import FieldString from "../../../generic/string/string"
import FieldConfig from "../../../../fields3/proto/field-config"
import {SortDirection} from "../../../../data-structures/sort"
import ItemModelV2 from "../../../../model2/item2/item-model"

export default class FieldTimeReportTitle extends FieldString {

    constructor(config: FieldConfig) {
        super(config)

        this.label = "Name"
    }

    listItemSortFunctions(direction: SortDirection) {
        return {
            functions  : [(listItem: ItemModelV2) => {
                return listItem.getName()?.toLowerCase() ?? listItem.item.id
            }],
            directions : [
                direction
            ]
        }
    }
}
